import React , {useState, useEffect} from 'react';
import NavbarHome from '../components/HomeComponents/NavbarHome';
import Footer from '../components/Footer';
import { Link, useParams } from 'react-router-dom';
import { getDocs , doc , db , collection ,getDoc , query ,where } from '../firebase';
import Aos from 'aos';
import "aos/dist/aos.css";
import SideFooter from '../components/SideFooter';

const SinglePlace = () => {

  let { placeId } = useParams();

  const [packageObject , setPackageObject] = useState({});
  
  const [ experinceArray , setExperincesArray ] = useState([]);

  const [ packagesArray , setPackagesArray ] = useState([]);

  useEffect(  () => {

    const getPackagesData = async () => { 

      const q = query(collection(db, "packages"), where("refere_location", "==",   packageObject.place_headline ) );
   
      const querySnapshot = await getDocs(q);
    
      const packagesDataArray = querySnapshot.docs ? querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id })) : '';
        
      setPackagesArray(packagesDataArray);
     
    }

 
    if (packageObject.place_headline !== undefined ) {

      getPackagesData();
    }
  } , [packageObject.place_headline]);

  useEffect(() => {

    window.scrollTo(0,0);
    
    const getProductsFromFirestore = async () => {
      const docRef = doc(db, "supported_places", placeId );
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
    
      setPackageObject(docSnap.data());
    } else {

      setPackageObject(null)
    }


    }
    getProductsFromFirestore();

  } , []);

  useEffect(() => {
    Aos.init( {  duration: 1200 } )
  } , []);

  useEffect(  () => {
 
    const getNotificationsData = async () => { 

      const q = query(collection(db, "experiences"), where("experince_location", "==", packageObject ? packageObject.place_headline : '' ) );
   
      const querySnapshot = await getDocs(q);
    
      const experincesDataArray = querySnapshot.docs ? querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id })) : '';

       
      setExperincesArray(experincesDataArray);
     
    }

    if (packageObject.place_headline !== undefined ) {

      getNotificationsData();
    }

  } , [packageObject.place_headline]);

  return (
    <div className="main_homepage" >

    
    <NavbarHome />

    <div className="explore_single_div " data-aos="zoom-out" data-aos-duration="450"   data-aos-easing="ease-in-quad" data-aos-mirror="true" style={{     background: `linear-gradient( to top ,rgba(0 ,0 ,0 ,0.7) , rgba( 0 ,0 ,0 ,0.4) ) , url('${packageObject ? packageObject.place_photo : ''}') center / cover no-repeat`  }}  >

<div className="content_top_explore">
<h1 className="heroarea_subheadline">  {packageObject ? packageObject.place_headline : ''} </h1>
<div className="underline_line_thick"></div>
</div>



<div className="mt-3 explore_content_area ">

<div className="d-flex f-sp f-wrap hero_sliding_div ">

<div className='content_info' >
<h1 className="heroarea_headline" > {packageObject ? packageObject.place_headline : ''} </h1>
<p className="main_para mt-1 color-white"> {packageObject ? packageObject.place_desc : ''}</p>

<button className="btn_category mt-2 w-50 bg_green"> أكتشف أكثر </button>
</div>



</div>



</div>
</div>

    <div className="section most_features_section container-sm">

    <div className="d-flex-c" data-aos="flip-right" data-aos-delay="30" data-aos-easing="ease" data-aos-mirror="true" >

<div className="info_box"></div>
<h1 className="main_headline">   التجارب السياحية </h1>
</div>


    <div className="mt-3 grid_places">

    {experinceArray && experinceArray.map(( { id , experince_name  , experince_photos , experince_price , experince_location } ) => (

      <div className="single_experince_div" data-aos="fade-up-right" data-aos-delay="20" data-aos-easing="linear" data-aos-mirror="true" data-aos-duration="250"  >

      <Link to={`/experinces/${id}`}>
      <img src={experince_photos[0]}  alt="" className="experince_img" />
      </Link>


    <div className=" body_experince_card">
    <p className="location_experince_sm mt-1-small"> {experince_location} </p>

    <h1 className="location_headline"> { experince_name }</h1>

    <p className="experince_price mt-1"> سعر يبدأ من   <br /> <span className="span_bold">{experince_price} ريال </span> </p>

    <Link to={`/experinces/${id}`}>
    <div className="d-flex-c f-sp">

    <button className="btn_category ">  احجز الان </button>

    <img src="/images/icons/left-arrow-purple.png" alt="" className="icon_experince" />
    </div>
    </Link>

    </div>

    </div>

    )) }

    </div>


    </div>

    <div className="section most_features_section container-sm">

    <div className="d-flex-c" data-aos="flip-right" data-aos-delay="30" data-aos-easing="ease" data-aos-mirror="true" >

<div className="info_box"></div>
<h1 className="main_headline">   البكجات السياحية </h1>
</div>


<div className="grid_packages mt-5">

{packagesArray && packagesArray.map(( { id , status , image , name , stars , description } ) => (


<div class="product" data-aos-duration="390" data-aos="fade-down" data-aos-delay="0" data-aos-easing="ease-out-sine" data-aos-mirror="true" >
<span class={`product__price ${status === 'most_people' && 'bg_purple'} ${status === 'most_popular' && 'bg_green'} ${status === 'new' && 'bg_yellow'}`}> 
  {status === 'most_people' && 'الأكثر شعبية'}
  {status === 'most_popular' && 'الأكثر مبيعا'}
  {status === 'new' && 'جديد'}
 </span>
<img class="product__image" src={image} />
<h1 class="product__title">  {name} </h1>
<hr />

  <div className="d-flex-c">
  <img src="/images/icons/star.png" alt="" className="star_icon_small_sm" />
    <img src="/images/icons/star.png" alt="" className="star_icon_small_sm" />
    <img src="/images/icons/star.png" alt="" className="star_icon_small_sm" />
    <img src="/images/icons/star.png" alt="" className="star_icon_small_sm" />
    <img src="/images/icons/star.png" alt="" className="star_icon_small_sm" />
  </div>

<p className='main_para mt-1' >
{description.substring(0 , 125)}
</p>

<Link to={`/package/${id}`} >
<button className="btn_category hover_package w-100 mt-1"  >     تصفح البكج </button>
</Link>

</div>


))}




</div>


    </div>

    <SideFooter />
    
    <Footer />
    </div>
  )
}

export default SinglePlace